export const LIST_BULK_PROCESS_REQUEST = 'LIST_BULK_PROCESS_REQUEST'
export const LIST_BULK_PROCESS_SUCCESS = 'LIST_BULK_PROCESS_SUCCESS'
export const LIST_BULK_PROCESS_FAIL = 'LIST_BULK_PROCESS_FAIL'

export const CREATE_BULK_PROCESS_REQUEST = 'CREATE_BULK_PROCESS_REQUEST'
export const CREATE_BULK_PROCESS_SUCCESS = 'CREATE_BULK_PROCESS_SUCCESS'
export const CREATE_BULK_PROCESS_FAIL = 'CREATE_BULK_PROCESS_FAIL'

export const GET_BULK_PROCESS_REQUEST = 'GET_BULK_PROCESS_REQUEST'
export const GET_BULK_PROCESS_SUCCESS = 'GET_BULK_PROCESS_SUCCESS'
export const GET_BULK_PROCESS_FAIL = 'GET_BULK_PROCESS_FAIL'

export const DETAIL_LIST_BULK_PROCESS_REQUEST = 'DETAIL_LIST_BULK_PROCESS_REQUEST'
export const DETAIL_LIST_BULK_PROCESS_SUCCESS = 'DETAIL_LIST_BULK_PROCESS_SUCCESS'
export const DETAIL_LIST_BULK_PROCESS_FAIL = 'DETAIL_LIST_BULK_PROCESS_FAIL'

export const EXPORT_DETAIL_BULK_PROCESS_REQUEST = 'EXPORT_DETAIL_BULK_PROCESS_REQUEST'
export const EXPORT_DETAIL_BULK_PROCESS_SUCCESS = 'EXPORT_DETAIL_BULK_PROCESS_SUCCESS'
export const EXPORT_DETAIL_BULK_PROCESS_FAIL = 'EXPORT_DETAIL_BULK_PROCESS_FAIL'